import React from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../../../../../../src/lib/component-base';
import { prefersMetricDistanceFormat } from '../../../../../../../../../../../src/lib/unit-measurement-format';

@componentBase('FlightMiniTrackerAltAndPhase')
export default class FlightMiniTrackerAltAndPhase extends React.Component {
  static propTypes = {
    defRowHeight: PropTypes.number,
    currentAltitude: PropTypes.number,
    currentPhase: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);

    const defHeight = 25;
    const topBottomPadding = 3;
    const rowHeight = (props.defRowHeight) ? `${props.defRowHeight - (topBottomPadding * 2)}px` :
      `${defHeight - (topBottomPadding * 2)}px`;

    this.muiDefaultProps = {
      rowDivStyle: {
        padding: `${topBottomPadding}px 0`,
        height: rowHeight,
      },
      colDivStyleParent: {
        padding: 0,
        height: 'inherit',
      },
      colDivStyleChild: {
        padding: 0,
        height: 'inherit',
      },
      colDivWithBkgStyle: {
        padding: 0,
        height: 'inherit',
        background: '#FF9600',
      },
      centerSpanStyleLabel: {
        position: 'absolute',
        top: '50%',
        WebkitTransform: 'translateY(-50%)',
        msTransform: 'translateY(-50%)',
        transform: 'translateY(-50%)',
        fontSize: '12pt',
        padding: '0 5px',
      },
      centerSpanStyleValue: {
        position: 'absolute',
        top: '50%',
        WebkitTransform: 'translateY(-50%)',
        msTransform: 'translateY(-50%)',
        transform: 'translateY(-50%)',
        fontSize: '12pt',
        fontWeight: 'bold',
        padding: '0 0 0 5px',
      },
    };
  }

  _getAltitude() {
    if (this.props.currentAltitude) {
      // this.props.currentAltitude -- in ft
      let altitude = this.props.currentAltitude;
      let altitudeUnits = 'ft';
      if (prefersMetricDistanceFormat(this.context.currentUser)) {
        altitude = Math.round(this.props.currentAltitude * 0.3048);
        altitudeUnits = 'm';
      }

      return `${altitude} ${altitudeUnits}`;
    }

    return '--';
  }

  _getPhase(shorthand) {
    if (this.props.currentPhase) {
      let and = 'AND ';
      if (this.props.currentPhase.toUpperCase() === 'LANDED') {
        and = '';
      }

      return `${and}${this.props.currentPhase.toUpperCase()}`;
    }

    if (shorthand) {
      return 'Positions Unavailable';
    }

    return 'No Positional Status Available';
  }

  render() {
    // console.log('[FlightMiniTrackerAltAndPhase] render : props', this.props);

    return (
      <div className='row' style={this.muiDefaultProps.rowDivStyle}>
        <div className='col-xs-6 col-sm-5 col-md-6 col-lg-5' style={this.muiDefaultProps.colDivStyleParent}>
          <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6' style={this.muiDefaultProps.colDivStyleChild}>
            <span style={this.muiDefaultProps.centerSpanStyleLabel}>ALTITUDE</span>
          </div>
          <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6' style={this.muiDefaultProps.colDivStyleChild}>
            <span style={this.muiDefaultProps.centerSpanStyleValue}>{ this._getAltitude() }</span>
          </div>
        </div>
        <div className='col-xs-6 col-sm-7 col-md-6 col-lg-7' style={this.muiDefaultProps.colDivWithBkgStyle}>
          <span className='hidden-xs hidden-md' style={this.muiDefaultProps.centerSpanStyleValue}>{ this._getPhase(false) }</span>
          <span className='visible-xs visible-md' style={this.muiDefaultProps.centerSpanStyleValue}>{ this._getPhase(true) }</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightPositionalInformationSection/children/FlightPositionalInformation/children/FlightMiniTracker/children/FlightMiniTrackerAltAndPhase.js